// extracted by mini-css-extract-plugin
export default {"supplier-match-form":"SupplierMatchForm_supplier-match-form__zR1fM"};